var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":"/temp/no_data.png","alt":"logo"}}),_c('span',[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }